module.exports = __webpack_public_path__ + "static/img/variable.c1c53b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cashflow-tour/variable.png
// module id = 2Cmb
// module chunks = 6